import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from "./context/LanguageContext"; 
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Participants from './pages/Participants';
import AddParticipant from './pages/AddParticipant';
import Login from './pages/Login';
import Register from './pages/Register';
import CertifCreate from "./pages/CertifCreate";
import Certifs from "./pages/Certifs";
import SearchResults from './pages/SearchResults';
import VerifyCertif from "./pages/VerifyCertif";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import PublicRoute from "./components/PublicRoute";
import PrivateRoute from "./components/PrivateRoute";
import Unauthorized from "./components/Unauthorized";
import NotFound from "./components/NotFound";
import RequestAccount from "./pages/RequestAccount";
import AdminRequests from "./pages/AdminRequests";
import BulkCreate from "./pages/BulkCreate";
import ManageThemes from "./pages/ManageThemes";
import Organizations from "./pages/Organizations";
import Admins from "./pages/Admins";
import OrganizationSetup from "./pages/OrganizationSetup";
import CertificateTemplateSettings from "./pages/CertificateTemplateSettings";
import OrganizationAdminRoute from "./components/OrganizationAdminRoute";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/participants" element={<PrivateRoute><Participants /></PrivateRoute>} />
          <Route path="/clients" element={<PrivateRoute><Clients /></PrivateRoute>} />
          <Route path="/add-participant" element={<PrivateRoute><AddParticipant /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/certificates/create/:participantId" element={<PrivateRoute><CertifCreate /></PrivateRoute>} />
          <Route path="/certificates/bulk" element={<PrivateRoute><BulkCreate /></PrivateRoute>} />
          <Route path="/certificates/:participantId" element={<PrivateRoute><Certifs /></PrivateRoute>} />
          <Route path="/results" element={<SearchResults />} />
          <Route path="/verify/:token" element={<VerifyCertif />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path="/requests/create" element={<PublicRoute><RequestAccount /></PublicRoute>} />
          <Route path="/requests/all" element={<PrivateRoute><AdminRequests /></PrivateRoute>} />
          <Route path="/themes/manage" element={<ManageThemes />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/organization-setup" element={<OrganizationSetup />} />
          <Route path="/organization/certificate-template" element={ <OrganizationAdminRoute><CertificateTemplateSettings /></OrganizationAdminRoute> } />
        </Routes>
      </Router>
    </LanguageProvider>
    // 👆 2. FERMETURE DU PROVIDER
  );
}

export default App;